import { parseWorkflowInstanceName } from './parseWorkflowInstanceName';

const WORKFLOW_LABELS: Record<string, string> = {
  abtest: 'experiment',
  rollout: 'rollout',
  reanalysis: 'reanalysis',
};

export const getWorkflowLabel = (resourcePath?: string): string => {
  if (!resourcePath) {
    return 'experiment';
  }

  try {
    const { workflow } = parseWorkflowInstanceName(resourcePath);
    return WORKFLOW_LABELS[workflow] ?? 'experiment';
  } catch {
    return 'experiment';
  }
};
